
export function pushEvent(event: any, searchType: string, pageType: string, searchQuery: string, userType: string, country: string) {
  const dataLayer = (window as any).dataLayer || [];
  if ('dataLayer' in window) {
    dataLayer.push({
      event,
      searchType,
      pageType,
      searchQuery,
      userType,
      countryCode: country,
    });      
  }
  else {
    throw new Error('Analytics is not supported');
  }
}
